<template>
    <div class="detail-container" v-loading="loading">
        <div class="btn-row">
            <div class="left">
                <el-button class="wl-green" @click="onCloseClick">
                    {{ $t('login_btn_back') }}
                </el-button>
            </div>
            <div class="right" id="right-container">
                <el-button v-if="getUser.userType == '1'" class="wl-green" @click="onNotifyClientClick">
                    <img :src="exportIcon">
                    {{ $t('ita_btn_notify_client') }}
                </el-button>
                <el-button v-if="getUser.userType == '1'" class="wl-green" @click="onArchiveQuestionnaireClick">
                    <img :src="exportIcon">
                    {{ $t('ita_btn_archive_questionnaire') }}
                </el-button>
            </div>
        </div>
        <div :class="['tab-row', getUser.userType == '2' ? 'tab-row-client' : '']">
            <div class="tab-arrows tab-arrows-left">
                <i :class="['tab-arrow', 'arrow-left', 'el-icon-caret-left', entityLeftDisable ? 'disabled': '']" @click="entityLeft"></i>
                <div class="丨"></div>
                <i :class="['tab-arrow', 'arrow-right', 'el-icon-caret-right', entityRightDisable ? 'disabled' : '']" @click="entityRight"></i>
            </div>
            <div
                v-for="(v, k) in displayEntities"
                :key="k"
                :class="['tab-entity', v.id == currentEntity ? 'tab-entity-active' : '']"
                :style="{visibility: v.id == -1 ? 'hidden' : ''}"
                @click="switchEntity(v)">
                {{ v.entityName }}
            </div>
            <div class="tab-arrows tab-arrows-right">
                <i :class="['tab-arrow', 'arrow-left', 'el-icon-caret-left', entityLeftDisable ? 'disabled': '']" @click="entityLeft"></i>
                <div class="丨"></div>
                <i :class="['tab-arrow', 'arrow-right', 'el-icon-caret-right', entityRightDisable ? 'disabled' : '']" @click="entityRight"></i>
            </div>
        </div>
        <div class="body">
            <div class="left">
                <div 
                    :class="['section-item', v.id == currentSection ? 'section-item-active' : '']"
                    v-for="(v, k) in displaySectionList"
                    :key="k">
                    <div class="title" @click="switchSection(v)">
                        <img class="icon" :src="statusIcon[`_${v.status}`]">
                        <div class="text">{{ v.sectionI18n }}</div>
                    </div>
                    <el-popover
                        placement="bottom-start"
                        trigger="click">
                        <i class="el-icon-more" slot="reference"></i>
                        <div class="section-popover">
                            <div class="section-popover-row" v-if="getUser.userType == '1'">
                                <div class="section-popover-title">{{ $t('ita_table_header_status') }}</div>
                                <el-select class="section-popover-select" v-model="v.status" @change="onSectionPopoverHide(v)">
                                    <el-option class="section-popover-option" v-for="(vv, kk) in statusOptions" :key="kk" :value="vv.value" :label="$t(vv.label)">
                                        <img :src="vv.icon" class="section-popover-option-img">
                                        <div class="section-popover-option-text">{{ $t(vv.label) }}</div>
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="section-popover-row">
                                <div class="section-popover-title">{{ $t('ita_table_header_client_responsible') }}</div>
                                <el-select class="section-popover-select" v-model="v.clientResponsible" @change="onSectionPopoverHide(v)">
                                    <el-option class="section-popover-option" v-for="(vv, kk) in clientOwnerList" :key="kk" :value="vv.userId" :label="vv.userName">
                                        <div class="section-popover-option-text">{{ vv.userName }}</div>
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="section-popover-row" v-if="getUser.userType == '1'">
                                <div class="section-popover-title">{{ $t('ita_table_header_period_date') }}</div>
                                <el-date-picker
                                    ref="datepicker"
                                    v-model="v.periodEndDate"
                                    class="wl-item wl-date-item input-with-select"
                                    type="date"
                                    :range-separator="$t('SITE_TO')"
                                    :start-placeholder="$t('create_date')"
                                    :end-placeholder="$t('create_date')"
                                    value-format="yyyy-MM-dd"
                                    @change="onSectionPopoverHide(v)"
                                ></el-date-picker>
                            </div>
                            <div class="section-popover-row" v-if="getUser.userType == '1'">
                                <div class="section-popover-title">{{ $t('ita_table_header_due_date') }}</div>
                                <el-date-picker
                                    ref="datepicker"
                                    v-model="v.dueDate"
                                    class="wl-item wl-date-item input-with-select"
                                    type="date"
                                    :range-separator="$t('SITE_TO')"
                                    :start-placeholder="$t('create_date')"
                                    :end-placeholder="$t('create_date')"
                                    value-format="yyyy-MM-dd"
                                    @change="onSectionPopoverHide(v)"
                                ></el-date-picker>
                            </div>
                        </div>
                    </el-popover>
                </div>
            </div>
            <div class="right">
                <div :class="['question-item', v.id == hightlightQuestionId ? 'question-item-highlight' : '']" v-for="(v, k) in displayDetailList" :key="k" :id="`question_${v.id}`">
                    <!-- 标题行 -->
                    <TitleRow
                        v-show="v.display" 
                        class="title-row" 
                        :titleText="`${v.seq}.${v.titleI18n}`"
                        :subtitleText="v.subTitleI18n"
                        :showIcon="v.seq && v.seq.indexOf('.') == -1">
                        <commentPopover slot="comment" :messageList="v.messageList" :summaryId="currentSummaryId" :questionId="v.id"></commentPopover>
                    </TitleRow>

                    <!-- 单选 -->
                    <template v-if="v.type == 'Radio' && v.display">
                        <el-radio-group class="radiogroup" v-model="v.answer" @input="e => radioChange(k, e)">
                            <el-radio v-for="(vv, kk) in v.optionsI18n" :key="kk" :label="`${kk - 0 + 1}`" :disabled="disableEdit">{{ vv }}</el-radio>
                        </el-radio-group>
                    </template>

                    <!-- 上传 -->
                    <template v-if="v.type == 'Upload' && v.display">
                        <UploadFile class="uploadfile" :currentSummaryId="currentSummaryId" :value="v.fileList" :disableEdit="disableEdit" :onChange="e => onUploadChange(k, e)"></UploadFile>
                    </template>

                    <!-- 富文本 -->
                    <template v-if="v.type == 'Long_Text' && v.display">
                        <richtextInput class="richinput" :disableEdit="disableEdit" :onChange="e => onRichTextChange(k, e)" :value.sync="v.answer"></richtextInput>
                    </template>
                    
                    <!-- 单行文本 -->
                    <template v-if="v.type == 'Short_Text' && v.display">
                        <el-input class="shortTextInput" :disabled="disableEdit" v-model="v.answer" :maxlength="500" show-word-limit @input="e => onShortTextInput(k, e)"></el-input>
                    </template>
                    
                    <!-- 表格 -->
                    <template v-if="v.type == 'Table' && v.display">
                        <freeTable class="freetable" :disableEdit="disableEdit" :columns="v.columnsI18n" :value="v.answer" :onChange="e => onFreeTableChange(k, e)"></freeTable>
                    </template>
                </div>

                <el-divider class="divider"></el-divider>

                <div class="btns" v-if="!disableEdit">
                    <el-button class="btn cancel-btn" @click="onCloseClick">{{ $t('btn_close') }}</el-button>
                    <el-button class="btn wl-green" @click="onSaveClick">{{ $t('btn_save') }}</el-button>
                    <el-button class="btn wl-green" @click="onSubmitClick" :disabled="disableEdit">{{ $t('btn_submit') }}</el-button>
                </div>
            </div>
        </div>
        <noticeUndone :show.sync="showNoticeUndone" :summaryList="noticeUndoneSummaryList"></noticeUndone>

    </div>
</template>
<script>
import exportIcon from '@/assets/img/icon-export.svg'
import icon1 from '@/assets/img/icon-not-started.svg'
import icon2 from '@/assets/img/icon-in-progress.svg'
import icon3 from '@/assets/img/icon-completed.svg'

import TitleRow from './modules/titleRow'
import richtextInput from './modules/richtextInput'
import freeTable from './modules/freetable'
import UploadFile from './modules/uploadFile'
import commentPopover from './components/commentPopover.vue'
import ItuEntity from './components/entity'


import { mapGetters } from "vuex"
import API from '@/api'
import {Encode64, Decode64, isIE, dateFormat} from '@/utils'
import noticeUndone from './components/noticeUndone'


export default {
    name: 'ITADetail',
    components: { TitleRow, richtextInput, freeTable, UploadFile, noticeUndone, commentPopover, ItuEntity },
    data() {return {
        exportIcon,

        sections: [],
        currentSection: '',
        clientOwnerList: [],
        statusOptions: [
            {
                label: 'ita_status_not_started',
                icon: icon1,
                value: '3',
                color: '#fd349c'
            },
            {
                label: 'ita_status_in_progress',
                icon: icon2,
                value: '2',
                color: '#3879eb'
            },
            {
                label: 'ita_status_icon_completed',
                icon: icon3,
                value: '4',
                color: '#00c0ae'
            },
        ],
        statusIcon: {
            _3: icon1,
            _2: icon2,
            _4: icon3
        },
        entities: [],
        currentEntity: '',
        loading: false,
        detailList: [],
        answerChanged: false,
        autoSaveNotify: null,
        autoSaveInterval: 300000,
        hightlightQuestionId: '',
        showNoticeUndone: false,
        noticeUndoneSummaryList: [],
        entityData: [],
        allEntityIds: []
    }},
    async mounted() {
        const currentEntity = this.$route.query.entityId
        const currentSection = this.$route.query.sectionId
        if (!currentEntity || !currentSection) {
            this.$router.push('/exchange')
        } else {
            this.currentEntity = currentEntity
            this.currentSection = currentSection
        }
        await this.init()

        /**
         * 自动保存: 客户端，状态非已完成
         */
        this.registAutoSave()
    },
    methods: {
        // 获取所有node的id && 默认选中
        getAllIds(data) {
            if( !data.disabled ){
                data.checked = true
                this.allEntityIds.push(data.id)
            }
            if (data.childEntity.length > 0) {
                data.childEntity.forEach(child => this.getAllIds(child));
            }
        },
        // 初始获取右侧entity信息
        getUserEntity: async function () {
            const {code, data} = await API.common.queryUserEntity({siteId: this.getSite.siteId, exchangeType: '0'})
            if (code == '1') {
                this.entityData = [data]
                this.allEntityIds = []
                this.getAllIds(this.entityData[0])
                this.$store.commit('common/setEntityIds', this.allEntityIds)
            } else {
                this.$message.error(this.$t(code));
            }
        },
        onCloseClick() {
            this.$router.push('/exchange?tabIndex=3')
        },
        /**
         * 将答案转为传给后端的（前端注释+可显示的html）内容
         * @param {*} v 
         */
        getAnswerHtml(v) {
            let answer = ''
            let answerHtml = ''
            switch (v.type) {
                case 'Radio': {
                    answer = v.answer
                    answerHtml = {
                        '1': '是|Yes',
                        '2': '否|No',
                        '3': '是，但并非针对提及的所有要素|Yes, but not for all elements mentioned'
                    }[v.answer] || ''
                } break
                case 'Upload': {
                    answer = JSON.stringify(v.answer)
                    if (v.answer && v.answer.length > 0) {
                        answerHtml = v.answer.map(vv => `<div class="filename">${vv.fileName}</div>`).join('')
                    } else {
                        answerHtml = ''
                    }
                } break
                case 'Long_Text': {
                    answer = v.answer ? v.answer : ''
                    answerHtml = `<div>${v.answer}</div>`
                } break
                case 'Short_Text': {
                    answer = v.answer ? v.answer : ''
                    answerHtml = `<div>${v.answer}</div>`
                } break
                case 'Table': {
                    answer = JSON.stringify(v.answer)
                    const answerCopy = JSON.parse(JSON.stringify(v.answer))

                     
                    if (answerCopy && answerCopy.length > 0) {
                        Object.keys(answerCopy).forEach(answerIndex => {
                            const answerItem = answerCopy[answerIndex]
                            Object.keys(answerItem).forEach(index => {
                                const item = answerItem[index]
                                 
                                if (index.indexOf('col_others_') > -1) {
                                    if (item) {
                                         
                                        answerItem[index.replaceAll('others_', '')] += `: ${item}`
                                        answerItem[index] = 'fly_answer'
    
                                         
                                    } else {
                                        answerItem[index] = 'fly_answer'
                                    }
                                }
                            })
                        })
                        answerHtml = [
                            '<table>',
                            '<tr>',
                            v.columnsI18n.map(label => `<th>${label.text}</th>`).join(''),
                            '</tr>',
                            answerCopy.map(ans => `<tr>${Object.values(ans).filter(v => v != 'fly_answer').map(_ans => `<td>${_ans}</td>`).join('')}</tr>`).join(''),
                            '</table>'
                        ].join("")
                    } else {
                        answerHtml = ''
                    }
                } break
            }

            return `<!--${Encode64(answer)}-->${answerHtml}`
        },
        /**
         * 从保存的答案中解码出回显的数据
         * @param {*} answer 
         */
        decodeAnswerHtml(v) {
            const matchAnswer = v.answer.answer.match(RegExp('\<\!\-\-(.*)\-\-\>'))
             
            if (!matchAnswer || !matchAnswer[1]) {
                return ''
            }
            const answer = Decode64(matchAnswer[1])

            switch (v.type) {
                case 'Radio': {
                    return answer
                }
                case 'Upload': {
                    return JSON.parse(answer)
                }
                case 'Long_Text': {
                    return answer
                }
                case 'Short_Text': {
                    return answer
                }
                case 'Table': {
                     
                    return JSON.parse(answer)
                }
            }
        },
        
        /**
         * 检查是否所有显示的问题都回答了
         */
        checkAllAnswer() {
            const findUnAnswer = this.displayDetailList.filter(v => v.display).find(v => {
                if (v.type == 'Table') {
                    return !v.answer || v.answer.length == 0 || v.answer.some(vv => Object.keys(vv).some(kkk => {
                        if (kkk.indexOf('_others_')) {
                            return ['其他', 'others'].includes(vv[kkk.replaceAll('others_', '')]) && !vv[kkk]
                        } else {
                            return !vv[kkk]
                        }
                    }))
                } else {
                    return !v.answer || v.answer.length == 0
                }
            })
            if (findUnAnswer) {
                this.$message.error(this.$t('itu_please_answer_all_question'))
                const originHash = window.location.hash
                window.location.hash = `question_${findUnAnswer.id}`
                window.location.hash = originHash
                this.hightlightQuestionId = findUnAnswer.id
                setTimeout(() => {
                    this.hightlightQuestionId = ''
                }, 2000);
                return false
            }

            return true
        },

        /**
         * 保存 & 提交
         * @param {*} status 状态：2保存，4提交
         */
        async handleSave(status) {
            if (status == 4 && !this.checkAllAnswer()) {
                return
            }
            this.loading = true
            let answerList = []
            const filterDisplayList = this.displayDetailList.filter(v => v.display)
            for (let i = 0; i < filterDisplayList.length; i ++) {
                const v = filterDisplayList[i]
                const findSection = this.sections.find(vv => vv.id == v.sectionId)
                let summaryId = ''
                let version = ''
                if (findSection && findSection.summary && findSection.summary.id) {
                    summaryId = findSection.summary.id
                }
                let fileList = []
                if (v.type == 'Upload' && v.answer && v.answer.length > 0) {
                    fileList = v.answer.map(vv => vv.fileId)
                }
                
                const answer = this.getAnswerHtml(v)

                const answerData = {
                    summaryId,
                    questionId: v.id,
                    answer,
                    version: v.version,
                    fileIdList: fileList
                }
                if (v.oriAnswer && v.oriAnswer.id) {
                    answerData.id = v.oriAnswer.id
                }
                if (v.oriAnswer && v.oriAnswer.version) {
                    answerData.version = v.oriAnswer.version
                }
                answerList.push(answerData)
            }
            
            
            const sendData = {
                summaryId: this.currentSummaryId,
                status,
                answerList
            }

            return API.exchange.saveAnswer(sendData).then(res => {
                if (res.code == '1') {
                    this.$message.success({
                        2: this.$t('msg_save_success'),
                        4: this.$t('msg_submit_success')
                    }[status])
                    this.init()
                     
                    this.answerChanged = false
                } else {
                    this.$message.error(this.$t(res.code))
                }
            }).finally(() => {
                this.loading = false
            })
        },

        /**
         * 注册自动保存
         */
        registAutoSave() {
            clearInterval(window.autoSaveIntervalInst)
            const currentSectionObj = this.sections.find(v => v.id == this.currentSection)
            if (this.getUser.userType == '2' && currentSectionObj && currentSectionObj.status && currentSectionObj.status != 4) {
                window.autoSaveIntervalInst = setInterval(() => {
                    this.autoSaveNotify = this.$notify({
                        title: this.$t('itu_auto_saving'),
                        dangerouslyUseHTMLString: true,
                        message: this.$t('itu_auto_saving_html'),
                        iconClass: 'el-icon-loading'
                    });
                    this.handleSave(2).finally(res => {
                        setTimeout(() => {
                            this.autoSaveNotify.close()
                        }, 1000) // 5分钟
                    })
                }, this.autoSaveInterval);    
            } else {
                 
                 
                 
                 
                 
            }
        },
        onSaveClick() {
            this.handleSave(2)
        },
        onSubmitClick() {
            this.handleSave(4)
        },
        onSectionPopoverHide(v) {
             
            let postData = { id: v.summary.id }
            if (v.clientResponsible) {
                postData.clientResponsible = v.clientResponsible
            }
            if (v.dueDate) {
                postData.dueDate = new Date(v.dueDate)
            }
            if (v.periodEndDate) {
                postData.periodEndDate = new Date(v.periodEndDate)
            }
            if (v.status) {
                postData.status = v.status - 0
            }
            
            API.exchange.itaUpdate(postData).then(res => {
                 
                if (res.code != '1') {
                    this.$message.error(this.$t(res.code))
                }
            }).catch(e => {
                console.error(e)
            }).finally(() => {
                 
            })
        },
        onUploadChange(k, e) {
            this.detailList[k].answer = e
             
            this.answerChanged = true
        },
        onFreeTableChange(k, e) {
            this.detailList[k].answer = e
             
            this.answerChanged = true
        },
        onShortTextInput(k, e) {
            this.detailList[k].answer = `${e}`
             
            this.answerChanged = true
        },
        onRichTextChange(k, e) {
            this.detailList[k].answer = `${e}`
             
            this.answerChanged = true
        },
        radioChange(k, e) {
            this.detailList[k].answer = `${e}`
             
            this.answerChanged = true
        },
        init() {
            this.loading = true
            return Promise.all([
                this.getUserEntity(),
                this.getDetail(),
                this.answerChanged = false,
                this.selectClientOwner()
            ]).finally(() => {
                this.loading = false
            })
        },
        getDetail() {
            return API.exchange.itaDetail({
                entityId: this.currentEntity,
                sectionId: this.currentSection,
                siteId: this.getSite.siteId,
                menuId:'20',
                userType:this.getUser.userType
            }).then(res => {
                if (res.code == '1') {
                    this.entities = res.data.clientEntityList.map(v => ({ selected: true, ...v }))
                    this.sections = res.data.questionnaireList.map(v => {
                        v.clientResponsible = v.summary.clientResponsible
                        v.dueDate = v.summary.dueDate
                        v.periodEndDate = v.summary.periodEndDate
                        v.status = v.summary.status
                        return v
                    })
                    this.detailList = res.data.detailList.map(v => {
                        if (v.answer) {
                            v.oriAnswer = JSON.parse(JSON.stringify(v.answer))
                             
                            v.answer = this.decodeAnswerHtml(v)
                        }
                        if (v.type == 'Upload') {
                            v.fileList = v.answer
                        }
                        return v
                    }).sort((a, b) => (a.seq - 0) - (b.seq - 0))
                } else if (res.code == 'ITU_SUMMARY_LOCK') {
                    this.$message.error(this.$t('itu_summary_lock', {username: res.data}))
                } else {
                    this.$message.error(this.$t(res.code))
                }
            }).finally(() => {
                setTimeout(() => {
                     
                    this.answerChanged = false    
                }, 500);
                
            })
        },
        selectClientOwner() {
            return API.matterLogs.searchClientOwner({siteId: this.getSite.siteId, searchContent: ''}).then(res => {
                if (res.code == '1') {
                    this.clientOwnerList = res.data
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        /**
         * 切换实体、切换章节、实体左右选择等，重新获取问题列表
         */
        async thenGetDetailList(callback) {
            const handler = async () => {
                window.location.hash = `#/ita?entityId=${this.currentEntity}&sectionId=${this.currentSection}`
                this.loading = true
                await this.getDetail()
                this.loading = false
                this.registAutoSave()
            }
            if (this.answerChanged) {
                await this.$confirm(this.$t('ita_unsave_answer_notice'), this.$t('COMMON_TIP'), {
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning'
                })

                this.answerChanged = false
                await callback()
                handler()
            } else {
                await callback()
                handler()
            }
        },
        entityLeft() {
            if (this.entityLeftDisable) return

            this.thenGetDetailList(() => {
                const findIndex = this.entities.findIndex(v => v.id == this.currentEntity)
                if (findIndex == -1) {
                    this.currentEntity = 0
                }
                if (findIndex - 1 >= 0) {
                    this.currentEntity = this.entities[findIndex - 1].id
                }
            })
        },
        entityRight() {
            if (this.entityRightDisable) return
            this.thenGetDetailList(() => {
                const findIndex = this.entities.findIndex(v => v.id == this.currentEntity)
                if (findIndex == -1) {
                    this.currentEntity = 0
                }
                if (findIndex + 1 < this.entities.length) {
                    this.currentEntity = this.entities[findIndex + 1].id
                }
            })
        },
        switchEntity(v) {
            this.thenGetDetailList(() => {
                this.currentEntity = v.id
            })
        },
        switchSection(v) {
            this.thenGetDetailList(() => {
                this.currentSection = v.id
            })
        },
        onNotifyClientClick() {
            this.showNoticeUndone = true
            this.noticeUndoneSummaryList = this.sections.map((v, k) => ({
                serialNoStr: `${k - 0 + 1}`,
                entityName: v.summary.entityName,
                sectionNameCn: v.sectionCn,
                sectionName: v.section,
                statusCn: {
                    3: '未开始',
                    2: '进行中',
                    4: '已完成'
                }[v.status - 0],
                status: {
                    3: 'Not started',
                    2: 'In progress',
                    4: 'Completed'
                }[v.status - 0],
                periodEndDateStr: v.periodEndDate ? dateFormat(new Date(v.periodEndDate), 'yyyy-MM-dd') : '',
                dueDateStr: v.dueDate ? dateFormat(new Date(v.dueDate), 'yyyy-MM-dd') : '',
                clientResponsible: v.clientResponsible
            }))
        },
        onArchiveQuestionnaireClick() {
            this.loading = true
            const findCurrentEntity = this.entities.find(v => v.id == this.currentEntity)
            const entityList = findCurrentEntity && findCurrentEntity.id && findCurrentEntity.entityName ? [{
                entityName: findCurrentEntity.entityName,
                id: findCurrentEntity.id
            }] : []
            API.exchange.ituExportZip({
                entityList,
                siteId: this.getSite.siteId
            }).then(res => {
                if (/application\/json/.test(res.data.type)) {
                    let reader = new FileReader()
                    reader.onload = e => {
                        if (e.target.readyState === 2) {
                            let resJson = {}
                            resJson = JSON.parse(e.target.result)
                            this.$message.error({ duration: 5000, message: this.$t(resJson.code) })
                        }
                    }
                    reader.readAsText(res.data)
                }
                if (/application\/octet-stream/.test(res.data.type)) {
                    let blob = new Blob([res.data])
                    const filename = decodeURI(res.headers['content-disposition'].replace('attachment; filename=', ''))
                    if (isIE()) {
                        navigator.msSaveBlob(blob, filename)
                    } else {
                        let url = window.URL.createObjectURL(blob)
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', filename)
                        document.body.appendChild(link)
                        link.click()
                    }
                }
            }).finally(() => {
                this.loading = false
            })
        }
    },
    computed: {
        // kp 端禁止编辑
        disableEdit() {
            const currentSectionObj = this.sections.find(v => v.id == this.currentSection)
            return this.getUser.userType == '1' || (currentSectionObj && currentSectionObj.status && currentSectionObj.status == '4')
        },
        displaySectionList() {
            return this.sections.map(v => {
                v.sectionI18n = this.$i18n.locale == 'zh' ? v.sectionCn : v.section

                return v
            })
        },
        displayDetailList() {
            let list = Object.assign([], this.detailList)

            return list.map(v => {
                v.titleI18n = this.$i18n.locale == 'zh' ? v.titleCn : v.titleEn

                // 根据条件计算是否显示
                v.display = false
                if (
                    !v.condition || 
                    v.condition == null || 
                    !v.condition.replaceAll(' ', '') // 咋还有只有一个空格的条件呢 condition:" "
                ) {
                    v.display = true
                } else if (v.condition.indexOf('OR') > -1) {
                    const conditions = v.condition.split('OR')
                    v.display = conditions.some(vv => {
                        let [key, value] = vv
                            .replaceAll('"', '')
                            .replaceAll(' ', '')
                            .replaceAll('(', '')
                            .replaceAll(')', '')
                            .split(',')
                        const findQuestion = this.detailList.find(_v => _v.titleAlias == key)
                        return findQuestion && findQuestion.answer && findQuestion.answer == value
                    })
                }
                /**
                 * 这个else中集合了如下两种判断条件
                 * 1) v.condition.indexOf('AND') > -1
                 * 2) v.condition 有值，但不是AND或OR连接的
                 * 
                 * 通常来说不存在AND和OR同时存在的情况。如果判断条件既没有AND也没有OR，那么用split处理后就会变成一个元素的数组，不影响后续判断
                 */
                else {
                    const conditions = v.condition.split('AND')
                    v.display = conditions.every(vv => {
                        let [key, value] = vv
                            .replaceAll('"', '')
                            .replaceAll(' ', '')
                            .replaceAll('(', '')
                            .replaceAll(')', '')
                            .split(',')
                        const findQuestion = this.detailList.find(_v => _v.titleAlias == key)
                        return findQuestion && findQuestion.answer && findQuestion.answer == value
                    })
                }


                if (v.type == 'Radio') {
                    v.optionsI18n = (this.$i18n.locale == 'zh' ? v.optionsCn : v.optionsEn).split('|')
                    v.answer = v.answer ? v.answer : ''
                }
                if (v.type == 'Long_Text') {
                    v.answer = v.answer ? v.answer : ''
                }
                if (v.type == 'Table') {
                    const options = (this.$i18n.locale == 'zh' ? v.optionsCn : v.optionsEn)
                    if (options) {
                        v.columnsI18n = options.split('|').map(vv => {
                            let options = []
                            let text = vv
                            if (vv.indexOf('[') > -1 && vv.indexOf(']') > -1) {
                                options = vv.substr(
                                    vv.indexOf('[') + 1,
                                    vv.indexOf(']') - vv.indexOf('[') - 1
                                ).split(',')
                                text = text.substr(0, text.indexOf('['))
                            } else {
                                options = null
                            }
                            return {options, text}
                        })
                    } else {
                        v.columnsI18n = []
                    }
                }
                v.subTitleI18n = ''
                if (this.$i18n.locale == 'zh' && v.helpTextCn) {
                    v.subTitleI18n = v.helpTextCn
                }
                if (this.$i18n.locale == 'en' && v.helpTextEn) {
                    v.subTitleI18n = v.helpTextEn
                }

                return v
            })
        },
        /**
         * 顶部显示的实体列表
         * 当前激活的实体，左面三个右面三个，左面不够往右补，右面不够往左补
         */
        displayEntities() {
            const entities = this.entities.filter(v => v.selected)
            let currentIndex = entities.findIndex(v => v.id == this.currentEntity)
            if (currentIndex == -1) {
                currentIndex = 0
            }
            
            let left = 3
            let leftRes = []
            let right = 3
            let rightRes = []
            for (let i = 1; i <= left; i ++) {
                if (currentIndex - i < 0) {
                    right ++
                } else {
                    leftRes.unshift(entities[currentIndex - i])
                }
            }
            for (let i = 1; i <= right; i ++) {
                if (currentIndex + i <= entities.length - 1) {
                    rightRes.push(entities[currentIndex + i])
                }
            }

            let res = [...leftRes, entities[currentIndex], ...rightRes]
            if (res.length < 7) {
                let firstIndex = entities.findIndex(v => v.id == res[0].id)
                for (let i = 1; i <= 7 - res.length + 1; i ++) {
                    res.unshift(entities[firstIndex - i])
                }
            }

            res = res.filter(v => !!v)

            if (res.length < 7) {
                res = [...res, ...new Array(7 - res.length).fill({id: -1, entityName: ''})]
            }
            return res
        },
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser',
            getEntityIds: 'getEntityIds',
        }),
        currentSummaryId() {
            const findSection = this.sections.find(v => v.id - 0 == this.currentSection - 0)
            return findSection && findSection.summary && findSection.summary.id ? findSection.summary.id : null
        },
        entityLeftDisable() {
            const displayEntities = this.displayEntities.filter(v => v.id != -1)
            if (!displayEntities || !displayEntities[0]) return false
            return this.currentEntity == displayEntities[0].id
        },
        entityRightDisable() {
            const displayEntities = this.displayEntities.filter(v => v.id != -1)
            if (!displayEntities || !displayEntities[displayEntities.length - 1]) return false
            return this.currentEntity == displayEntities[displayEntities.length - 1].id
        }
    },
    watch: {
        answerChanged(v) {
            window.__itu_answerChanged = v
        }
    }
}
</script>
<style scoped>
.detail-container {
    display: flex;
    flex-direction: column;
    margin: 0 20px;
    height: 100%;
    overflow-y: hidden;
}
.detail-container .btn-row{
    width: 100%;
    /*height: 30px;*/
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 8px 0;
}
.detail-container .btn-row .left {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}
.detail-container .btn-row .right {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
.detail-container .tab-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    background-color: #f6f6f6;
    border-bottom: solid 1px #e6e6e8;
}
.detail-container .tab-row-client {
    /* margin-top: 20px; */
}
.detail-container .tab-row .tab-arrows {
    width: 65px;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    border-radius: 7px;
    border: solid 1px #e5e6e8;
}
.detail-container .tab-row .tab-arrows-left {
    margin-left: 20px;
    margin-right: 20px;
}
.detail-container .tab-row .tab-arrows-right {
    margin-right: 20px;
}
.detail-container .tab-row .tab-arrows .tab-arrow {
    font-size: 15px;
    cursor: pointer;
}
.detail-container .tab-row .tab-arrows  .丨 {
    width: 1px;
    height: 40%;
    border-right: solid 2px #edeeef;
}
.detail-container .tab-row .tab-arrows .arrow-left {
    margin-left: 10px;
}
.detail-container .tab-row .tab-arrows .arrow-right {
    margin-right: 10px;
}
.detail-container .tab-row .tab-arrows > .disabled {
    cursor: not-allowed;
    color: gray;
}
.detail-container .tab-row .tab-entity {
                        /* 左右边距    两边箭头组件宽度  一行7个 */
    width: calc((100% - (2 * 20px) - (2 * 65px)) / 7);
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    cursor: pointer;
}
.detail-container .tab-row .tab-entity-active {
    border-top: solid 3px #3879eb;
    height: calc(100% + 3px);
    background-color: #fff;
    padding-bottom: 3px;
    font-weight: 700;
    color: #3879eb;
}
.detail-container .body {
    width: 100%;
    /*                  btnrow  margin    tab-row*/
    height: calc(100% - 30px - 2 * 20px - 60px);
    background-color: white;
    display: flex;
    flex-direction: row;
    overflow-y: hidden;
}
.detail-container .body .left {
    width: 12%;
    height: 100%;
    border-right: solid 1px #e5e6e8;
}
.detail-container .body .left .section-item {
    width: 100%;
    padding: 0 20px;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
.detail-container .body .left .section-item .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
}

.detail-container .body .left .section-item .title .text {
    font-size: 14px;
    margin-left: 10px;
}
.detail-container .body .left .section-item .title .icon {
    width: 15px;
    height: 15px;
}

.detail-container .body .left .section-item-active .title .text{
    font-weight: 600;
    color: #3d7ceb;
}
.detail-container .body .left .section-item ::v-deep .el-icon-more {
    transform: rotate(90deg);
    cursor: pointer;
}
.detail-container .body .right {
    width: 88%;
    height: 100%;
    overflow-y: scroll;
    /* padding-bottom: 50px; */
}
.detail-container .body .right .question-item {
    transition: all linear 0.5s;
}
.detail-container .body .right .question-item-highlight {
    background-color: #ffe793;
}
.detail-container .body .right .question-item .title-row {
    margin: 40px 30px 10px 30px;
}
.detail-container .body .right .question-item .richinput {
    width: 90%;
    margin-left: 5%;
    resize: vertical;
}
.detail-container .body .right .question-item .freetable {
    margin-left: 5%;
}
.detail-container .body .right .question-item .uploadfile {
    width: 40%;
    margin-left: 5%;
}
.detail-container .body .right .question-item .radiogroup {
    margin-left: 5%;
    margin-top: 10px;
}
.detail-container .body .right .question-item .shortTextInput {
    margin-left: 5%;
    width: calc(95% - 30px);
}
.detail-container .body .right .divider {
    width: 96%;
    margin-left: 2%;
    margin-top: 40px;
}
.detail-container .body .right .btns {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding-right: 30px;
}
.section-popover {
    display: flex;
    flex-direction: column;
}
.section-popover .section-popover-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
}
.section-popover .section-popover-row .section-popover-title {
    width: 120px;
}
.section-popover-option {
    display: flex;
    flex-direction: row;
    align-items: center;   
}
.section-popover-option-text {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 2px;
    margin-left: 5px;
}
</style>